import { toast } from 'sonner'
import { useState, useEffect } from 'react'
import { fError } from '@/utils/format-error'
import { useBoolean } from '@/hooks/use-boolean'
import { useParams } from '@/routes/hooks/use-params'
import axiosInstance, { endpoints } from '@/lib/axios'
import LoadingSection from '@/components/loading-indicator/loading-section'

import type { Article } from '../types'

import ArticleForm from '../article-form'

// ----------------------------------------------------------------------

export default function ArticleFormView() {
  const params = useParams()
  const loading = useBoolean(true)
  const [article, setArticle] = useState<Article | undefined>(undefined)
  const isEditMode = params.id !== undefined

  const fetchArticle = async () => {
    if (!isEditMode || !params.id) {
      loading.onFalse()
      return
    }

    try {
      loading.onTrue()
      const { data } = await axiosInstance.get<Article>(
        endpoints.articles.detail(params.id),
      )
      setArticle(data)
    } catch (error) {
      toast.error(fError(error))
    } finally {
      loading.onFalse()
    }
  }

  useEffect(() => {
    fetchArticle()
  }, [params.id])

  return (
    <LoadingSection loading={loading.value}>
      <ArticleForm article={article} mode={isEditMode ? 'edit' : 'create'} />
    </LoadingSection>
  )
}
